import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { ApprovalService } from '@core/services/approval.service';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { NotificationFacade } from '@core/facades/notification.facade';
import {
  DropDownModel,
} from '@shared/ui/dropdown/dropdown.component';
import { Subscription } from 'rxjs';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { dropdownMenuAnimation } from '@shared/animations/animations';
import { environment } from '@core/environments/environment';
import { PermissionDirective } from "@shared/directives/permission.directive";

@Component({
  selector: 'app-approvals',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './approvals.component.html',
  styleUrl: './approvals.component.scss',
  animations: [dropdownMenuAnimation],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    PermissionDirective
],
})
export class ApprovalsComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  filterMenuState: 'visible' | 'hidden' = 'hidden';
  // approvals$;

  isDropdownVisible = true;
  showDropdown = false;
  subs: Subscription[] = [];
  documentList: any[] = [];
  actionList: DropDownModel[] = [];
  totalPending = 0;
  totalApproved = 0;
  totalReq = 0;
  totalCount!: number;
  date = new FormControl('', [Validators.required]);

  currentPage: number = 1;

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  notify = inject(NotificationFacade);
  approval = inject(ApprovalService);
  change = inject(ChangeDetectorRef);
  breadCrumbService = inject(BreadCrumbService);
  $index: any;
  kycUpdatesUrl!: string;
  docUpdloadUrl!: string;
  partnerKycUrl!: string;

  openDocument(data: any) {
    window.open(`${environment.FILE_BASE_URL}${data.link}`, '_blank');
  }

  toggle() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  getDocumentsMetaData() {
    const sub = this.approval.getDocumentsMetaData().subscribe({
      next: (resp: any) => {
        this.totalReq = resp.data.total_docs;
        this.totalPending = resp.data.pendind_doc_count;
        this.totalApproved = resp.data.approved_doc_count;

        this.change.detectChanges();
      },
    });
    this.subs.push(sub);
  }

  updateMetaData(actionType: 'approved' | 'rejected') {
    if (actionType === 'approved') {
      this.totalPending = Math.max(0, this.totalPending - 1);
      this.totalApproved = this.totalApproved + 1;
    } else if (actionType === 'rejected') {
      this.totalPending = Math.max(0, this.totalPending - 1);
    }

    this.change.detectChanges();
  }

  ngOnInit() {
    this.kycUpdatesUrl = `/admin/approvals/kyc-updates`;
    this.docUpdloadUrl = `/admin/approvals/documents`;
    this.partnerKycUrl = `/admin/approvals/partner-kyc`;
    this.breadCrumbService.setPageBreadCrumb(this.activatedRoute);
    this.getDocumentsMetaData();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
